<template>
    <div> 
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <h5>Fiscalizações</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="fiscalizacoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="ativa" slot-scope="data">
                        <!-- <app-status
                            :status="data.ativa ? 'SIM' : 'NÃO'"
                        ></app-status> -->
                    </template> 
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @click="criarFiscalizacao()"
                                >Criar fiscalização</b-button
                            >
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="abrirFiscalizacao(data)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import FiscalizacoesServicos from './FiscalizacoesServicos'

export default {
    components: {},

    data() {
        return {
            fiscalizacoes: [],
            fiscavlizacao: {},
            campos: [
                {
                    key: 'codigoContrato',
                    label: 'Código Contrato',
                    filterable: true,
                    sortable: true,
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true,
                },

                {
                    key: 'processoFiscalizacao',
                    label: 'Processo de fiscalização',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataFiscalizacao',
                    label: 'Data da fiscalização',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterFiscalizacoes() {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.fiscalizacoes = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter fiscalizações',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    
        criarFiscalizacao() {
            this.$router.push({ name: `${this.$route.name}_Inserir` })
        },

        abrirFiscalizacao(fiscalizacao) {
            this.$router.push({
                name: `${this.$route.name}_Detalhar`,
                params: {
                    fiscalizacaoId: fiscalizacao.idFiscalizacao
                }
            })
        }
    },

    created() {
        this.obterFiscalizacoes()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Fiscalizações'
        }
    },

    watch: {
        $route(to, from) {
            if (from.name === 'Fiscalizações_Inserir' || from.name === 'Fiscalizações_Detalhar') {
                this.obterFiscalizacoes()
            }
        },
    }
}
</script>
